export const menuRoles = {
    itemMenu: {
        omcdb: {
            roles: ['OMCDB_EXTERNO']
        }
    }
};
